import InitialState from '../InitialState';
import { useEffect } from 'react';
var useInitialState = function (initialState, resetDataCb, _a) {
    var paused = _a.paused;
    var resetInitialState = function () { return InitialState.setInitialState(JSON.stringify(initialState)); };
    useEffect(function () {
        resetInitialState();
    }, []);
    useEffect(function () {
        if (JSON.stringify(initialState) !== InitialState.getInViewFormInitialState()) {
            if (!paused) {
                resetDataCb();
                resetInitialState();
            }
        }
    }, [initialState]);
};
export default useInitialState;
//# sourceMappingURL=useInitialState.js.map